import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ScrollToTop = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  const openWhatsApp = () => window.open('https://wa.me/+27683882389', '_blank');

  return (
    <div className="fixed md:bottom-10 bottom-10 right-5 md:right-20 flex gap-2 z-30">
      <div
        onClick={scrollToTop}
        className="w-14 h-14 md:w-12 md:h-12 bg-xencode-contact-black text-white rounded-full flex items-center justify-center hover:bg-xencode-gold hover:cursor-pointer shadow-md border border-xencode-gold"
      >
        <FontAwesomeIcon icon={faArrowUp} />
      </div>
      <div
        onClick={openWhatsApp}
        className="w-14 h-14 md:w-12 md:h-12 bg-green-500 text-white rounded-full flex items-center justify-center hover:bg-green-600 hover:cursor-pointer shadow-md"
      >
        <FontAwesomeIcon icon={faWhatsapp} />
      </div>
    </div>
  );
};
